import LoadingGif from '../static/img/loading.gif';

const Loading = () => {
  return (
    <div className='loading'><img src={LoadingGif} alt='loading'/></div>
  )
}

export default Loading